import { cn } from '@/lib/utils'

type SpinnerProps = {
  size?: 'sm' | 'md' | 'lg'
  className?: string
  label?: string
}

const sizeMap = {
  sm: 'size-4 border-2',
  md: 'size-6 border-2',
  lg: 'size-10 border-[3px]',
}

export function Spinner({ size = 'md', className, label }: SpinnerProps) {
  return (
    <div
      role="status"
      aria-label={label ?? 'Đang tải'}
      className={cn('inline-flex items-center gap-2 text-fg-muted', className)}
    >
      <span
        className={cn(
          'inline-block animate-spin rounded-full border-current border-t-transparent',
          sizeMap[size],
        )}
      />
      {label && <span className="text-sm">{label}</span>}
    </div>
  )
}
